/* eslint-disable max-statements */
import React, { useEffect } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import {  trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import TrackImpression from "../../shared/track-impression";
import parseAvailabilityData from "../../../utils/helpers/parse-availability-data";
// import Overview from "./overview";
// import {getFastlyImage} from "../../../utils/helpers/get-image-from-path";
// import CdpTryLoanCalculator from "../cdp-try-loan-calculator/component";
// import { useEwVariantConfig } from "../../../hooks/use-ew-variant-config";
import { NUMBER } from "../../../constants/app-constants";

// eslint-disable-next-line complexity
const AboutThisCarRevamp = ({
    content = {},
    // config = {},
    carDetailsRef,
    userDeliveryState = {},
    getDeliveryInfoConnect,
    getPreApprovalLoanDetailsConnect
    // handleCalculator = () => {},
    // desktopCdpEw,
    // paymentSummaryData
}) => {
    const { overview = {}, appointmentId, oldTimer
    // ewDetails = {}
    } = content;
    const {carData = []} = overview || {};
    const showFinanceFirstExperimentVariant = true;
    // const { showEwVariantA, showEwVariantB } = useEwVariantConfig(desktopCdpEw, paymentSummaryData, ewDetails);
    // const showLoanCal = (!showEwVariantA && showEwVariantB) || false;

    useEffect(() => {
        if (appointmentId && userDeliveryState && userDeliveryState.code) {
            //appointmentId, pincode = state_pincode, pickup =false
            getDeliveryInfoConnect(appointmentId, userDeliveryState.pincode, "", false).then(({availabilityDetail
            }) => {
                const { homeDelivery = "", pickupDelivery = "" } = availabilityDetail  && userDeliveryState.pincode ? parseAvailabilityData(availabilityDetail) : {};
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CDP_DELIVERY_TIMELINE, {eventLabel: {
                    userState: userDeliveryState.code,
                    deliveryTAT: homeDelivery,
                    pickupTAT: pickupDelivery
                }});
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId, userDeliveryState]);

    useEffect(() => {
        if (oldTimer) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CDP_NO_SERVICE_OLD_TIMER);
        }
    }, [oldTimer]);

    useEffect(() => {
        if (showFinanceFirstExperimentVariant) {
            getPreApprovalLoanDetailsConnect();
        }
    }, [getPreApprovalLoanDetailsConnect, showFinanceFirstExperimentVariant]);
    return (
        <div>
            <TrackImpression event={{ name: "aboutThisCarViewd" }}>
                <div ref={carDetailsRef} />
                {/* <div styleName={"styles.overViewContainer"}>
                        <Overview
                            content={content}
                            config={config}
                        />
                    </div> */}
                <div styleName={"styles.aboutThisCar"}>
                    <p styleName={"styles.commentsFromDealerHeading"}>Overview of the car</p>
                    <div styleName={"styles.optionWrapper"}>
                        {(carData || []).slice(0, NUMBER.SIX).map((item, index) => (
                            <div className={"media"} key={index}>
                                {/* <img src={getFastlyImage(config, item.image)} /> */}
                                <div className={"media-body"}>
                                    <p styleName={"styles.title"}>{item?.label}</p>
                                    <p styleName={"styles.subTitle"}>{item.value}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* { showLoanCal && <CdpTryLoanCalculator handleCalculatorClick={handleCalculator}/>} */}
            </TrackImpression>
        </div>
    );
};

AboutThisCarRevamp.propTypes = {
    content: PropTypes.object,
    serviceHistoryRef: PropTypes.object,
    carDetailsRef: PropTypes.object,
    warrantyPlanInfo: PropTypes.object,
    eligibleForExtendedWarranty: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    showDeliveryTimeLine: PropTypes.bool,
    userDeliveryState: PropTypes.object,
    setDeliveryTimelineConnect: PropTypes.func,
    deliveryInfo: PropTypes.object,
    getDeliveryInfoConnect: PropTypes.func,
    config: PropTypes.object,
    oldTimerBanner: PropTypes.string,
    setPreApprovedOriginConnect: PropTypes.func,
    preApproved: PropTypes.bool,
    firstName: PropTypes.string,
    maxPermissibleRepaymentPerWeek: PropTypes.number,
    getPreApprovalLoanDetailsConnect: PropTypes.func,
    absolutePermissibleLoanAmount: PropTypes.number,
    handleCalculator: PropTypes.func,
    desktopCdpEw: PropTypes.object,
    paymentSummaryData: PropTypes.object
};

export default AboutThisCarRevamp;
